import { PARTNERS, RECOGNITIONS } from "@/data/content";

export function PartnersMarquee() {
  const doubled = [...PARTNERS, ...PARTNERS];
  return (
    <div data-testid="partners-marquee" className="relative overflow-hidden py-10 border-y border-neutral-100">
      <div className="marquee-track flex items-center gap-16 px-6">
        {doubled.map((p, i) => (
          <div key={i} className="shrink-0 h-12 flex items-center opacity-70 hover:opacity-100 transition-opacity">
            <img src={p.src} alt={p.name} className="h-10 md:h-12 w-auto object-contain" loading="lazy" />
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />
    </div>
  );
}

export function RecognitionsStrip({ dense = false }) {
  return (
    <div data-testid="recognitions-strip" className={`flex flex-wrap items-center justify-center gap-x-10 gap-y-6 ${dense ? "" : "py-6"}`}>
      {RECOGNITIONS.map((r) => (
        <div key={r.name} className="flex flex-col items-center gap-2 opacity-80">
          <img src={r.src} alt={r.name} className="h-16 md:h-20 w-auto object-contain" loading="lazy" />
          <span className="text-[11px] uppercase tracking-[0.22em] text-neutral-700 font-bold">{r.name}</span>
        </div>
      ))}
    </div>
  );
}
